import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { AssetMobileVersions } from "~/_components/AssetMobileVersions";
import { QueryParamNames } from "~/constants/search";
import { useGoToAssetPage } from "~/hooks/useGoToAssetPage";
import { centralizedClipIdSelector } from "~/store/centralizedClip/selectors";
import { usePublicVersionsList } from "~/swr-hooks/versions/usePublicVersionsList";
export const PublicAssetMobileVersion = /*#__PURE__*/ memo(()=>{
    const { data: versions } = usePublicVersionsList();
    const clipId = useSelector(centralizedClipIdSelector);
    const { goToAssetPage } = useGoToAssetPage();
    const onVersionClick = useCallback((version)=>{
        if (version.id === clipId) {
            goToAssetPage({
                asset: version,
                query: {
                    [QueryParamNames.tab]: null,
                    [QueryParamNames.timestamp]: null,
                    [QueryParamNames.discussionId]: null
                }
            });
        }
    }, [
        clipId,
        goToAssetPage
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "min-h-full w-full",
        children: /*#__PURE__*/ _jsx(AssetMobileVersions, {
            isActiveVersion: (version)=>version.id === clipId,
            onVersionClick: onVersionClick,
            versions: versions === null || versions === void 0 ? void 0 : versions.data.clips
        })
    });
});
PublicAssetMobileVersion.displayName = "PublicAssetMobileVersion";
